import React, { memo, useEffect, useRef, useState } from 'react';
import { differenceInMilliseconds, parseISO } from 'date-fns';
import { formatMilliseconds } from '../../../../utils/date/date';
import styled from 'styled-components';
import { LTT_TIMER_TEST_ID, SLA_TIMER_TEST_ID } from './constants';

export const TIMER_COLORS = {
  RED: '#d0021b',
  YELLOW: '#ddd109',
  GREEN: '#00ae46',
};

interface ITimer {
  className?: string;
  subtrahendTime: string; // время назначения менеджера (для SLA) или время создания тикета (для LTT) в формате ISO
  seconds: number; // значение SLA/LTT в секундах
  type: 'SLA' | 'LTT';
}

const Timer = ({ className, subtrahendTime, seconds, type }: ITimer) => {
  const [time, setTime] = useState(
    differenceInMilliseconds(new Date(), parseISO(subtrahendTime))
  );

  useEffect(() => {
    const updateTimer = () => {
      setTime(differenceInMilliseconds(new Date(), parseISO(subtrahendTime)));
    };

    updateTimer();
    const timerInterval = setInterval(updateTimer, 5000);

    return () => {
      clearInterval(timerInterval);
    };
  }, [subtrahendTime]);

  const timerBg = () => {
    const sla_ltt = seconds * 1000;
    if (time <= sla_ltt / 2) return TIMER_COLORS.GREEN;
    if (sla_ltt / 2 < time && time < sla_ltt) return TIMER_COLORS.YELLOW;
    if (time >= sla_ltt) return TIMER_COLORS.RED;
    return TIMER_COLORS.GREEN;
  };

  return (
    <StyledTimerWrapper>
      {`${type}: `}
      <StyledTimer
        className={className}
        $bgColor={timerBg()}
        data-testid={type === 'SLA' ? SLA_TIMER_TEST_ID : LTT_TIMER_TEST_ID}
      >
        {formatMilliseconds(time)}
      </StyledTimer>
    </StyledTimerWrapper>
  );
};

const StyledTimerWrapper = styled.div`
  display: inline-block;
`;

const StyledTimer = styled.div<{ $bgColor: string }>`
  display: inline-block;
  padding: 2px 6px;
  background: ${({ $bgColor }) => $bgColor};
  color: #fff;
  font-weight: 600;
  font-size: 10px;
  border-radius: 4px;
`;

export default memo(Timer);
